import {Component, Inject} from '@angular/core';
import {DialogResult, DialogResultType} from '../DialogResult';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs/internal/Observable';

export enum RecurringPodType {
  Weekly = 1,
  Monthly = 2
}

export class RecurringPodDialogData {
  podRecurringId: number;
  podLayoutId: number;
  recurringType: RecurringPodType;
  emailTo: string;
  dayOfWeek: number | undefined;
  dayOfMonth: number | undefined;
}

export class RecurringPodDialogResult {
  podRecurringId: number;
  podLayoutId: number;
  recurringType: RecurringPodType;
  emailTo: string;
  dayOfWeek: number | undefined;
  dayOfMonth: number | undefined;
}

@Component({
  selector: 'recurring-pod-dialog',
  templateUrl: './recurring-pod-dialog.component.html',
})
export class RecurringPodDialogComponent {

  results: RecurringPodDialogResult = {
    podRecurringId: 0,
    podLayoutId: 0,
    recurringType: RecurringPodType.Weekly,
    emailTo: "example@example.com",
    dayOfWeek: 0,
    dayOfMonth: 1
  };

  constructor(
    public dialogRef: MatDialogRef<RecurringPodDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RecurringPodDialogData
  ) {

    this.results.podRecurringId = data.podRecurringId;
    this.results.podLayoutId = data.podLayoutId;
    this.results.recurringType = RecurringPodType.Weekly;
    this.results.emailTo = data.emailTo;
    this.results.dayOfWeek = data.dayOfWeek;
    this.results.dayOfMonth = data.dayOfMonth;

    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  public Result: DialogResult;

  static showDialog(
    dialog: MatDialog,
    podRecurringId: number,
    podLayoutId: number,
    recurringType: RecurringPodType,
    emailTo: string,
    dayOfWeek: number | undefined,
    dayOfMonth: number | undefined
  ): Observable<any> {
    const params: RecurringPodDialogData = {
      podRecurringId,
      podLayoutId,
      recurringType,
      emailTo,
      dayOfWeek,
      dayOfMonth
    };

    const dialogRef = dialog.open(RecurringPodDialogComponent, {
      disableClose: true,
      width: '750px',
      data: params,
    });

    return dialogRef.afterClosed();
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultData = this.results;
    this.Result.ResultType = DialogResultType.Ok;
    this.dialogRef.close(this.Result);
  }
}
